<div class="pt-header">
  <div class="pt-header__icon">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#50327d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
      <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
      <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
    </svg>
  </div>
  <div class="pt-header__text">
    <h3>Renters insurance policy</h3>
    <div class="pt-header__meta">
      <span>{{ policy.policyNumber }}</span>
      <ng-container *ngIf="policy.accountName">
        <span class="pt-header__dot"></span>
        <span>{{ policy.accountName }}</span>
      </ng-container>
    </div>
  </div>
  <span class="pt-badge" [ngClass]="badges[state].className">
    <span class="pt-badge__dot"></span>{{ badges[state].label }}
  </span>
</div>
